import DigiobcanApi from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';

/** Zdroje noviniek (feedy) so stavom posledného importu. */
export const getNewsFeeds = createQueryFn(
  QueryNameSpace.getNewsFeeds,
  async () => {
    const { news_feeds } = await DigiobcanApi.getNewsFeeds();
    return news_feeds;
  },
);
